<template>
<span v-if="isVisible()">
    <el-button
      id="btn-clear-put-away"
      class="button-clear-put-away"
      type="success"
      plain
      @click="handleClearPutAway"
      size="mini"
      v-show="displayButton"
    >
      {{ $t('outbound.units.clearPutAway') }}
    </el-button>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { OUTBOUND_UNITS_CLEAR_PUT_AWAY, OUTBOUND_UNITS_SEARCH } from '@/store/actions';
import constants from '@/utils/constants';

export default {
  name: 'ClearPutAwayButton',
  props: {
    displayButton: Boolean,
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      clearPutAway: OUTBOUND_UNITS_CLEAR_PUT_AWAY,
      search: OUTBOUND_UNITS_SEARCH,
    }),
    async handleClearPutAway() {
      const confirm = await this.$confirm(
        this.$t('outbound.units.clearPutAwayConfirmation')
          .replace('[numberOfUnits]', this.outboundUnits.total), { confirmButtonText: this.$t('common.yes') }
      ).catch(() => {});

      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          const response = await this.clearPutAway().catch(() => {});
          this.$message.success(response.message);
          this.search({});
        } finally {
          loading.close();
        }
      }
    },
    isVisible() {
      const hasUnits = this.outboundUnits.list && this.outboundUnits.list.length > 0;
      const hasClearPutAwayPermission = this.$can(this.permissions.OUTBOUND.CLEAR_PUT_AWAY);
      return hasUnits && hasClearPutAwayPermission;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.button-clear-put-away {
  margin-right: 10px;
}
</style>
